<template>
<div class="row">
    <div class="col-2 line">{{departure.mode.number}}</div>
    <div class="col-6 destination">{{departure.mode.destination}}</div>
     <div class="col-2 time" v-if="departure.dateTime.rtTime">{{timeInMinutes}}</div>
     <div class="col-2 time" v-else>{{departure.dateTime.time}}</div>
     <div class="col-2 note"><marquee behavior="scroll" v-if="departure.notes"><span v-html="cleanFromHTMLTags(departure.notes.note.header)"></span>&nbsp;<span v-html="cleanFromHTMLTags(departure.notes.note.text)"></span></marquee></div>
</div>
</template>

<script>

var moment = require('moment')

export default {
  name: 'DepartureElement',
  props: {
    departure: Object
  },
  data: () => {
    return {
      timeInMinutes: '',
      timers: {
        minutes: ''
      }
    }
  },
  created: function () {
    this.calculateMinutes()
    this.timers.minutes = setInterval(this.calculateMinutes, 10000)
  },
  methods: {
    cleanFromHTMLTags: function (html) {
      let cleanText = html
      if (html != null) { cleanText = html.replace(/<\/?[^>]+(>|$)/g, '') }
      return cleanText
    },

    calculateMinutes: function () {
      try {
        let rtTime = this.departure.dateTime.rtTime
        let time = rtTime + ' +01'
        let mTime = moment(time, 'HH:mm ZZ')
        let now = moment()
        let timeDif = mTime.diff(now, 'minutes')

        let timeDisp

        if (timeDif > 10) {
          timeDisp = `${rtTime}*`
        } else if (timeDif > 0) {
          timeDisp = `${timeDif} Min.`
        } else if (timeDif <= 0) {
          timeDisp = `Jetzt`
        } else {
          timeDisp = rtTime
        }

        this.timeInMinutes = timeDisp
      } catch (e) {
        console.log(e)
        this.timeInMinutes = false
      }
    },
    beforeDestroy () {
      clearInterval(this.timers.minutes)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.line{
    text-align: center;
}

.destination {
    text-align: left
}

.row {
  font-size: 4.5rem;
  font-weight: 600;
}

.time {
  text-align: center;
}
</style>
